import { FileText, Download } from "lucide-react";
import MarketingFooter from "../components/MarketingFooter";
import MarketingPageShell from "../components/MarketingPageShell";
import usePageMeta from "../hooks/usePageMeta";

const DOCS = [
  {
    t: "Key Facts Statement",
    d: "Plain-language summary of what is covered, cooling-off, and how claims are decided.",
    href: "/api/pdfs/kfs/en",
    lang: "English",
    type: "pdf",
  },
  {
    t: "Key Facts Statement (Swahili)",
    d: "Kifupi cha kile kinachofunikwa, muda wa kupoa, na jinsi madai yanavyoamuliwa.",
    href: "/api/pdfs/kfs/sw",
    lang: "Swahili",
    type: "pdf",
  },
  {
    t: "Policy Wording",
    d: "Full legal cover terms including exclusions, limits, and the claims procedure.",
    href: "#",
    lang: "EN · placeholder",
    type: "pdf",
  },
  {
    t: "Claims Guide",
    d: "Step-by-step explainer on submitting a claim, what evidence to send, and what to expect.",
    href: "#",
    lang: "EN · placeholder",
    type: "pdf",
  },
  {
    t: "Complaints Procedure",
    d: "How we handle complaints, our response timelines, and the IRA escalation route.",
    href: "/complaints",
    lang: "Page",
    type: "page",
  },
  {
    t: "Privacy Notice",
    d: "What data we collect, how we use it, and your rights under Kenya's Data Protection Act.",
    href: "/privacy",
    lang: "Page",
    type: "page",
  },
];

export default function PolicyDocuments() {
  usePageMeta({
    title: "Policy Documents — Fortiqa",
    description:
      "Download Fortiqa's Key Facts Statement, policy wording, claims guide, complaints procedure, and privacy notice.",
  });
  return (
    <div className="min-h-screen bg-[#f4f2eb] text-[#1b1d1c]" data-testid="policy-documents-page">
      <MarketingPageShell
        eyebrow="Legal · Policy"
        title="Policy documents."
        intro="Everything you need to read before signing up — and to refer back to when you have a claim. Available in English and Swahili, downloadable as PDF."
        testid="policy-documents"
      >
        <section className="px-6 lg:px-10 max-w-7xl mx-auto pb-24 grid sm:grid-cols-2 gap-5">
          {DOCS.map((d) => (
            <a
              key={d.t}
              href={d.href}
              target={d.type === "pdf" && d.href !== "#" ? "_blank" : undefined}
              rel="noreferrer"
              className="group rounded-2xl bg-white border border-[#114232]/10 hover:border-[#114232]/30 p-7 flex items-start gap-5 transition-all hover:shadow-md"
              data-testid={`doc-${d.t.toLowerCase().replace(/\s+|\(|\)/g, "-")}`}
            >
              <div className="w-12 h-12 rounded-xl bg-[#114232]/8 grid place-items-center shrink-0 group-hover:bg-[#114232]/14 transition-colors">
                <FileText className="w-5 h-5 text-[#114232]" strokeWidth={1.7} />
              </div>
              <div className="flex-1">
                <div className="font-heading text-base font-bold text-[#114232]">{d.t}</div>
                <p className="text-sm text-[#5c6360] leading-relaxed mt-1.5">{d.d}</p>
                <div className="text-xs text-[#5c6360] mt-3 inline-flex items-center gap-1.5 font-mono">
                  <Download className="w-3 h-3" /> {d.lang}
                </div>
              </div>
            </a>
          ))}
        </section>
      </MarketingPageShell>
      <MarketingFooter />
    </div>
  );
}
